/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import { isEmpty } from '@ember/utils';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import AlertsService from 'cio/services/alerts';
import AuthService from 'cio/services/auth';
import PushService from 'cio/services/push';
import { tracked } from '@glimmer/tracking';

interface ContentSignature {
  Element: HTMLDivElement;
  Args: {
    selectedFile: File | null;
    isEditing: boolean;
    errors: Record<string, any>[];
    isDisabled: boolean;
    keyID: string | null;
    teamID: string | null;
    bundleID: string | null;
    sendToSandbox?: boolean;
    updateSendToSandbox: (checked: boolean) => unknown;
    onFileSelected: (selectedFile: File) => unknown;
    updateSandboxConfig: (sendToSandbox: boolean) => unknown;
  };
}

export default class Content extends Component<ContentSignature> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service alerts!: AlertsService;
  @service auth!: AuthService;
  @service push!: PushService;

  @tracked showSendToSandboxModal = false;

  get noApnsCredentials() {
    return this.push.credentials.apns == null;
  }

  get isNewOrEditing() {
    if (!this.args.isDisabled && !this.noApnsCredentials) {
      return this.args.isEditing;
    }

    return true;
  }

  get isEnabledAndNotEditing() {
    return !this.isNewOrEditing;
  }

  get disableInput() {
    return (
      !this.auth.hasPermission('journeys/push_message_settings/edit') ||
      this.push.isAnyRequestRunning ||
      !this.args.isEditing
    );
  }

  get fileSelectTooltip() {
    return this.disableInput ? 'Click Edit Authorization to upload file.' : 'Upload .p8 key file';
  }

  updateSandboxConfig = task(async (sendToSandbox) => {
    await this.args.updateSandboxConfig(sendToSandbox);
    this.showSendToSandboxModal = false;
  });

  @action
  fileSelected(file: File, resetInput: () => unknown) {
    if (isEmpty(file)) {
      return;
    }

    this.args.onFileSelected(file);
    resetInput();
  }

  @action
  onSendToSandboxChange(checked: boolean, { event }: { event: Event }) {
    if (this.isNewOrEditing) {
      this.args.updateSendToSandbox(checked);
    } else {
      event.preventDefault();
      this.showSendToSandboxModal = true;
    }
  }
}
